import React from 'react';

import { months } from '../../helpers';

interface Props {
  load: any;
  date: MonthlyReportDate;
}

function MonthPickerItem(props: Props) {
  return (
    <li
      className="date-item date"
      onClick={() => props.load(props.date)}
      role="button"
      style={{ height: '40px', lineHeight: '23px' }}
    >
      <div className="menu-text" style={{ paddingLeft: '30px' }}>
        {months[props.date.month - 1]}
      </div>
    </li>
  );
}

export default MonthPickerItem;
